module.exports = __webpack_public_path__ + "img/app-tab.64a6812a.png";